import styles from "./Loader.less";
export const Loader = () => {
  return <div className={styles.loader} data-sentry-component="Loader" data-sentry-source-file="index.tsx">
      <span className={styles.bar} />
      <span className={styles.bar} />
      <span className={styles.bar} />
      <span className={styles.bar} />
      <span className={styles.bar} />
    </div>;
};